import { Outlet, Link } from 'react-router-dom';
import './AuthLayout.css';

export default function AuthLayout() {
  return (
    <div className="auth-layout">
      <div className="auth-left">
        <div className="auth-left-content">
          <Link to="/" className="auth-logo" aria-label="Heka.care home">
            <img
              src="/logo.png"
              srcSet="/logo-small.png 240w, /logo-email.png 480w, /logo.png 1160w"
              sizes="260px"
              alt="Heka.care — Telehealth for Ghana"
              width="260"
              height="61"
              style={{ height: 52, width: 'auto', display: 'block', filter: 'brightness(0) invert(1)' }}
              decoding="async"
              fetchPriority="high"
            />
          </Link>
          <h1>Healthcare, Finally For Every Ghanaian</h1>
          <p>
            Book doctors virtually or in person, manage your medications, order
            pharmacy deliveries, and access NHIS benefits.
          </p>
          <div className="auth-left-features">
            <div className="auth-left-feat">{'\u2713'} NHIS Integrated</div>
            <div className="auth-left-feat">{'\u2713'} 256-bit Encrypted</div>
            <div className="auth-left-feat">{'\u2713'} Works Offline</div>
            <div className="auth-left-feat">{'\u2713'} All 16 Regions</div>
          </div>
        </div>
      </div>
      <div className="auth-right">
        {/* Mobile header: logo + back-to-home. Hidden on desktop — the left pane covers that. */}
        <div className="auth-mobile-header">
          <Link to="/" className="auth-mobile-back" aria-label="Back to homepage">
            <span aria-hidden="true" style={{ fontSize: 16, marginRight: 6 }}>{'\u2190'}</span>
            Back
          </Link>
          <Link to="/" className="auth-mobile-logo" aria-label="Heka.care home">
            <img
              src="/logo.png"
              srcSet="/logo-small.png 240w, /logo-email.png 480w, /logo.png 1160w"
              sizes="160px"
              alt="Heka.care"
              height="36"
              style={{ height: 36, width: 'auto', display: 'block' }}
              decoding="async"
            />
          </Link>
          <span aria-hidden="true" style={{ width: 52 }} />
        </div>
        <Outlet />
      </div>
    </div>
  );
}
